// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T16:17:37.199Z
// Property: Carriage House (ID: 6737460151192634)
// Collections: 23 amenities, 18 floorplans (live), 27 photos, 74 POIs, 5 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192634",
  "property_external_id": "4857246",
  "property_zillow_url": "https://www.zillow.com/apartments/savannah-ga/carriage-house/5Xnx9P/",
  "property_apartments_url": "https://www.apartments.com/carriage-house-savannah-ga/81xj9h1",
  "property_google_business_url": "https://www.google.com/maps/place/Carriage+House/data=!4m2!3m1!1s0x0:0xb5d32d9b69dd107a?sa=X&ved=2ahUKEwjX45vEyLySAxUHPhAIHQe6EyMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321177756",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "carriage-house",
  "property_name": "Carriage House",
  "property_website_url": "https://www.carriagehousesavannah.com/",
  "property_domain": "https://www.carriagehousesavannah.com/",
  "property_address": "125 Tibet Ave",
  "property_full_address": "125 Tibet Ave, Savannah, GA 31406",
  "property_address_1": "125 Tibet Ave",
  "property_address_2": null,
  "property_address_city": "Savannah",
  "property_address_state": "GA",
  "property_address_zip_full": "31406-5549",
  "property_address_zip": "31406",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Wilshire Estates-Savannah Mall",
  "property_address_latitude": "31.9897896",
  "property_address_longitude": "-81.1347876",
  "property_email": "carriagehouse@rreafresidential.com",
  "property_phone": "(912) 244-7881",
  "property_call_tracking_phone": "912-301-3556",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>At Carriage House in scenic Savannah, GA, find the perfect apartment home, flat, or townhome to complement your lifestyle. Choose from spacious one-, two-, and three-bedroom floor plans, with select homes featuring private brick-enclosed patios. Enjoy resort-inspired amenities, including a sparkling swimming pool, modern fitness center, and inviting outdoor lounge. Browse our available homes or schedule a tour today!</p>",
  "property_long_description": "<p>Welcome to Carriage House, where spacious apartment homes, flats, and townhomes offer comfortable living in beautiful Savannah, Georgia. Explore thoughtfully designed one-, two-, and three-bedroom floor plans with the space and flexibility to complement your lifestyle. Select homes also feature private brick-enclosed patios, creating the perfect outdoor retreat for relaxing or entertaining.</p><p><br></p><p>Enjoy community amenities designed to make every day more convenient and enjoyable. Take a refreshing swim in the sparkling swimming pool, stay active in the fitness center, or gather with friends at the outdoor grilling and lounge area. Scenic walking and biking trails provide even more ways to unwind and enjoy the outdoors.</p><p><br></p><p>Carriage House also offers convenient on-site maintenance, a renters insurance program, and an on-site tanning salon. With Savannah’s historic charm, vibrant culture, shopping, dining, and entertainment within easy reach, you’ll have everything you need close to home.</p><p>Discover the comfort and convenience of life at Carriage House. Browse our available Savannah apartment homes, flats, and townhomes, or schedule a personalized tour today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-e9c8-7283-8072-dc90241364e5.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
    "public_id": "019e1de4-e9c8-7283-8072-dc90241364e5",
    "storage_key": "property/6737460151192634/019e1de4-e9c8-7283-8072-dc90241364e5.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.05555555555556",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$199\nApplication Fee\n$50",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "450",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No more than two pets per apartment.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://carriagehousesavannah.loftliving.com/login",
  "property_apply_now_url": "https://8747935.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-e628-774c-a43d-c46cf93982cc.webp",
  "property_primary_logo_media": {
    "alt_text": "Carriage House Apartment Homes logo",
    "public_id": "019e1de4-e628-774c-a43d-c46cf93982cc",
    "storage_key": "property/6737460151192634/019e1de4-e628-774c-a43d-c46cf93982cc.webp",
    "width": 898,
    "height": 413
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-e5e4-7075-8f17-ecf23ce4aa2a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Carriage House Apartment Homes logo",
    "public_id": "019e1de4-e5e4-7075-8f17-ecf23ce4aa2a",
    "storage_key": "property/6737460151192634/019e1de4-e5e4-7075-8f17-ecf23ce4aa2a.webp",
    "width": 898,
    "height": 413
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-e5e4-7075-8f17-ecf23ce4aa2a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Carriage House Apartment Homes logo",
    "public_id": "019e1de4-e5e4-7075-8f17-ecf23ce4aa2a",
    "storage_key": "property/6737460151192634/019e1de4-e5e4-7075-8f17-ecf23ce4aa2a.webp",
    "width": 898,
    "height": 413
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-e628-774c-a43d-c46cf93982cc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Carriage House Apartment Homes logo",
    "public_id": "019e1de4-e628-774c-a43d-c46cf93982cc",
    "storage_key": "property/6737460151192634/019e1de4-e628-774c-a43d-c46cf93982cc.webp",
    "width": 898,
    "height": 413
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#162f79",
  "property_secondary_color": "#dee5f2",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "775 - 1142",
  "property_sqft_min": "775",
  "property_sqft_max": "1142",
  "property_price_range": "1765",
  "property_price_min": "1235",
  "property_price_max": "1765",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/CarriageHouseAptsSavannah",
  "property_instagram_url": "https://www.instagram.com/carriage_house_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJi5un9OV0-4gRehDdaZst07U",
  "property_youtube_url": "https://www.youtube.com/watch?t=59&v=zrbSQ1C9T1U",
  "property_yelp_url": "https://www.yelp.com/biz/carriage-house-apts-savannah",
  "property_tiktok_url": "https://www.tiktok.com/@carriage.house.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Carriage House",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Welcome home to <a href=\"/floor-plans/\">Carriage House Apartment Homes</a> in Savannah, Georgia! Residents can find the balance between work and play in our prime location, and understand the comforts of easy southern living in our pet-friendly community. We are just minutes away from amazing local restaurants and cafes, cinemas, shopping, and gyms. As well as a close location to incredible parks for those who love the outdoors.</p>",
  "property_home_floorplans_blurb": "<p>Located in Savannah, GA we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Carriage House is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Carriage House in Savannah, GA, your ideal home awaits with spacious one, two, and three-bedroom floor plans. Enjoy resort-style amenities, from a refreshing pool to cozy courtyards and planned social activities. Picture yourself living here, where comfort meets community in a smoke-free environment designed for modern lifestyles.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Savannah, GA, Carriage House offers a variety of thoughtfully designed floor plans, from cozy one-bedroom to spacious three-bedroom layouts. Embrace the vibrant neighborhood and uncover local treasures just steps from your door. Dive into the community experience and see what awaits you nearby!",
  "property_home_reviews_blurb": "Nestled in the heart of Savannah, Carriage House offers more than just a place to live; it’s a vibrant community. Residents rave, “The friendly atmosphere and beautiful amenities make this place feel like home.” Dive into their stories and see why Carriage House is the perfect choice for you!",
  "property_neighborhood_blurb": "<p>Located in Savannah, GA we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Carriage House is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Unwind after a hard day of work at our swimming pool with large pool deck & comfy lounge chairs. If you prefer to let the stress melt from your shoulders with company, invite friends and family to grill at our picnic area. Residents won’t have to worry at <a href=\"/floor-plans/\">Carriage House Apartment Homes</a> with our on-site maintenance with 24-Hour emergency service, and our flexible leasing terms. Our community welcomes your pets with wide-open arms, so contact our Savannah, GA management team for a tour today!</p>",
  "property_applynow_blurb": "At Carriage House in Savannah, GA, spacious one, two, and three-bedroom floor plans await your personal touch. Dive into resort-style amenities like a sparkling pool, a state-of-the-art fitness center, and scenic walking trails. Embrace the lifestyle you deserve—secure your new home and lease online today!",
  "property_contactus_blurb": "At Carriage House in charming Savannah, GA, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options. Each layout embraces comfort, style, and functionality, making it easy to find your perfect home. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Carriage House in Savannah, GA, our diverse floor plans cater to every lifestyle, whether you seek a cozy one-bedroom or a spacious three-bedroom haven. Have questions? Our FAQs page is here to guide you through all aspects of our charming community. Find the information you need today!",
  "property_floorplans_blurb": "<p>Our one, two, and three bedroom apartments for rent are designed with your convenience in mind. You can enjoy designer living with our <a href=\"/amenities/\">chic amenities</a> like decorative light fixtures & window coverings, a kitchen pantry, central air conditioning with ceiling fans in prime living areas, and washer and dryer connections. Impress any company you bring over with your cooking on our energy-efficient black appliances. Some apartment homes feature durable wood-look flooring, faux-granite countertops, and a private patio or balcony with storage closet.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Carriage House in Savannah, GA, choose from spacious one, two, and three-bedroom floor plans nestled among scenic walking and biking trails. Enjoy resort-style amenities, including a sparkling pool, fitness center, and inviting lounge. Use our interactive community map to find your ideal apartment today—your vibrant new lifestyle awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Carriage House in charming Savannah, GA, spacious one, two, and three-bedroom floor plans beckon you to embrace a vibrant lifestyle. Great friends make great neighbors—invite your pals to share in the exceptional comforts of our community. Refer a friend today and enrich your living experience together!",
  "property_residentaccess_blurb": "Welcome to Carriage House in the heart of Savannah, GA, where your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans tailored for comfort. Elevate your living experience—access your resident portal today to pay rent, schedule maintenance, and enjoy seamless community living!",
  "property_reviews_blurb": "At Carriage House in Savannah, GA, residents rave about the welcoming atmosphere, with one stating, “The sense of community here is unmatched!” Immerse yourself in a vibrant lifestyle surrounded by friendly neighbors and exceptional amenities. See what our residents have to say about living at our community!",
  "property_created_at": "1752257255802",
  "property_scheduletour_blurb": "At Carriage House in charming Savannah, GA, you’ll find the perfect backdrop for your life. Choose from thoughtfully designed one, two, and three-bedroom floor plans that cater to your unique lifestyle. Ready to envision your new home? Schedule a tour today and see what our residents love about living here!",
  "property_thankyou_blurb": "Thank you for your inquiry about Carriage House in beautiful Savannah, GA! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Our team will reach out soon to help you take the next exciting step toward comfortable living in our vibrant community.",
  "property_virtualtours_blurb": "<p>At Carriage House, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Carriage House",
  "property_seo_title_home": "Carriage House | Apartments in Savannah, GA",
  "property_seo_description_home": "Welcome to Carriage House in beautiful Savannah, GA, where contemporary living meets Southern charm! Choose from stylish one, two, and three-bedroom floor plans designed to fit your lifestyle. Dive into relaxation by our shimmering pool, break a sweat in our state-of-the-art fitness center, or savor a sunny afternoon at our inviting lounge. With on-site maintenance and a comprehensive renters insurance program, your peace of mind is prioritized. Plus, enjoy grilling with friends and exploring scenic walking and biking trails. Your dream home awaits—make it a reality today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Savannah, GA",
  "property_seo_description_floorplans": "Unlock your ideal living space at Carriage House in vibrant Savannah, GA. With stylish one, two, and three-bedroom floor plans, you’ll find the perfect blend of comfort and modern design. Each layout is thoughtfully crafted to elevate your lifestyle. Browse through our diverse options and step into your dream apartment today!",
  "property_seo_title_amenities": "Amenities | Savannah, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience the perfect blend of comfort and convenience at Carriage House in Savannah, GA. Enjoy sun-soaked afternoons by the pool, energizing workouts in our fully-equipped fitness center, and relaxing evenings at the lounge or grill area. With spacious one, two, and three-bedroom floor plans, our apartments cater to every lifestyle. Take advantage of our on-site maintenance, renters insurance program, and explore scenic walking and biking trails right outside your door. Dive into a vibrant community that offers both tranquility and excitement—your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Savannah, GA",
  "property_seo_description_gallery": "Unveil the essence of your dream home at Carriage House in Savannah, GA! Our stunning photo gallery showcases stylish one, two, and three-bedroom apartments nestled within a vibrant community. Picture life lounging by the pool, breaking a sweat in our fitness center, or grilling with friends on sunny afternoons. With on-site maintenance and a unique renters insurance program, your comfort is our priority. Take a stroll or bike along scenic trails and imagine the possibilities—your new lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Carriage House Apartments",
  "property_seo_description_virtualtours": "Step into the Carriage House experience in Savannah, GA, where modern comfort meets Southern charm. With thoughtfully designed one, two, and three-bedroom apartments, your ideal home awaits! Immerse yourself in our vibrant community—take a virtual tour today and see why Carriage House is the perfect place to call home!",
  "property_seo_title_interactivemap": "Interactive Map | Carriage House Apartments",
  "property_seo_description_interactivemap": "\"Uncover the charm of Carriage House in Savannah, GA, where every day feels like a vacation. With thoughtfully designed one, two, and three-bedroom floor plans, plus amenities like a refreshing pool, cutting-edge fitness center, and serene walking/biking trails, you’ll find the perfect blend of comfort and community. Ready to find your sanctuary? Use our interactive community map to navigate available apartments and pricing. Your ideal home awaits!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Savannah, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Carriage House in charming Savannah, GA! With our diverse floor plans—one, two, and three bedrooms—you'll find the perfect home base. Dive into local favorites and hidden gems just steps away from our community; your ideal lifestyle awaits. Don’t miss out on nearby attractions and eateries designed to enhance your living experience!",
  "property_seo_title_contact": "Contact Us | Carriage House",
  "property_seo_description_contact": "\"At Carriage House in Savannah, GA, we offer a variety of spacious floor plans to suit your lifestyle, including one, two, and three-bedroom apartments designed for comfort and modern living. Whether you’re seeking a cozy retreat or a family-friendly space, our dedicated leasing team is here to assist you. Have questions? Reach out today and let’s find your perfect home!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Savannah, GA",
  "property_seo_description_faqs": "Uncover everything you need to know about Carriage House in Savannah, GA! Our Frequently Asked Questions page dives into the highlights of our community, from spacious one to three-bedroom floor plans to top-notch amenities like a refreshing pool, a state-of-the-art fitness center, and inviting walking/biking trails. Whether you're curious about our tanning salon or on-site maintenance, we've got you covered. Find clarity and comfort in your future home—browse our FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Savannah, GA",
  "property_seo_description_reviews": "Uncover the vibrant lifestyle at Carriage House in Savannah, GA, where residents enjoy a range of modern amenities including a sparkling pool, fitness center, and inviting lounge. From spacious one to three-bedroom floor plans, our community caters to diverse living styles. Dive into the experiences of our residents and find out why they're passionate about calling Carriage House home. See what our residents have to say about living at our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Savannah, GA",
  "property_seo_description_applynow": "\"At Carriage House in the heart of Savannah, GA, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans that perfectly fit your lifestyle. Dive into relaxation by the pool, energize your day at our fitness center, or unwind in our stylish lounge. Enjoy the convenience of on-site maintenance and exclusive amenities like a grilling area and tanning salon. Ready for your next adventure? Secure your future in our vibrant community—lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Carriage House",
  "property_seo_description_residentaccess": "\"Welcome to the Carriage House in Savannah, GA! Log in to your resident portal for seamless rent payments, hassle-free maintenance requests, and your key to enhanced living. Experience convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Carriage House",
  "property_seo_description_referafriend": "\"Think your friends would love the charm of Carriage House in Savannah, GA? Spread the joy of community living and refer a friend today! Great friends make fabulous neighbors—let's build a vibrant community together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Carriage House",
  "property_seo_description_scheduletour": "\"Step into a world of charm and elegance at Carriage House, nestled in the heart of Savannah, GA. Experience modern living with historic allure—schedule a tour of our inviting community today and envision your new home!\"",
  "property_seo_title_privacy": "Privacy Policy | Carriage House",
  "property_seo_description_privacy": "At Carriage House in Savannah, GA, your trust is paramount. Our privacy policy carefully outlines how we protect your personal information while fostering a vibrant community. Curious about our commitment to your privacy? View our privacy policy today to learn more!",
  "property_seo_title_accessibility": "Website Accessibility | Carriage House",
  "property_seo_description_accessibility": "\"At Carriage House in Savannah, GA, we believe in making everyone feel at home. Our Accessibility Statement highlights our commitment to digital inclusion and providing seamless living experiences for all. Learn how we ensure our community is welcoming and accessible to everyone.\"",
  "property_seo_title_sitemap": "Sitemap | Carriage House",
  "property_seo_description_sitemap": "\"Navigate your way to your dream home at Carriage House in Savannah, GA! Our comprehensive sitemap offers an easy route to explore our community's amenities, floor plans, and everything else we have to offer. Ready to find your perfect fit? Check it out!\"",
  "property_seo_title_thankyou": "Thank You | Carriage House",
  "property_seo_description_thankyou": "Thank you for reaching out to Carriage House in scenic Savannah, GA! Your interest is appreciated—our team is eager to connect and help you find the perfect home that blends comfort and charm. Stay tuned for a personalized response! ",
  "property_seo_title_pets": "Pet Policy | Apartments in Savannah, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293635205",
  "amenities": [
    {
      "id": "custom_08bf5901-d314-48da-8604-ba1bd636ca57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf0163e7-7dd3-4fc8-b1b6-ddca2b88db8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_713b970f-c8b3-4cb1-87f5-797ab7b891d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Business Office with Copier and Scanner",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25b90671-8f32-4062-a32c-4f9e819abcf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96a2a6e0-9615-42e0-abd9-adedcae13c3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87424548-307a-4418-8efe-33f36b84ce33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c59888c8-34d6-4c60-89d7-cd68c63a8421",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area with Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be050ba9-84d9-4621-b1e6-49f38291f8b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d600522-fcf7-40a5-90cc-65182b86cd92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f1849d4-6627-4f89-8bb3-9c18921634f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Deep Swimming Pool with Large Pool Deck & Comfy Lounge Chairs",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc77c3c8-3730-48e2-ae6d-0ead67db7a38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious & Comfortable 1, 2 & 3 Bedroom Homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2701320-5fc1-4c5a-bbbb-e99af141a073",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Decorative Light Fixtures & Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_977b3d1f-59fb-410a-82b3-04af9a1ecb0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Durable Wood‑Look Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cff51fa-30b9-4049-b46d-e50d7a0cc214",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Faux‑Granite Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14bcb653-34cc-4402-80df-066daab2f7b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c376478-92b7-44e2-ba28-df3bdca90730",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑efficient Black Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66e7e376-64dc-4c0d-bd53-26bbe18a7b0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Home*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7c7d81e-e075-443e-8554-a6a12080cc86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4b82fd2-e028-483b-82a7-e1187cf83bce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony with Storage Closet*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8c3ed05-709e-4bdf-a9a5-a8bb5a723571",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_afa89b2f-3bbc-4e84-8253-561b8859f875",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36fe633e-719c-408a-9e4b-8b6a4d6352bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2485870a-09a1-481d-b1da-68283acf6b8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_857ade2e-dc27-4749-80d0-2689bf332610",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/01a00208-5dba-7768-8c05-5e41deb9d22e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "01a00208-5dba-7768-8c05-5e41deb9d22e",
        "storage_key": "property/6737460151192634/01a00208-5dba-7768-8c05-5e41deb9d22e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded areas. Perfect for a refreshing dip on a warm day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_271c87d0-b1b6-4460-a6c3-b9f12d9e02c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/01a00208-5d1f-72e4-9ec7-36d77d9b2fb1.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "01a00208-5d1f-72e4-9ec7-36d77d9b2fb1",
        "storage_key": "property/6737460151192634/01a00208-5d1f-72e4-9ec7-36d77d9b2fb1.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, complete with comfortable lounge seating and shaded areas.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2d57e17-43f9-4a90-b966-f693a683a66a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-984d-74ba-acc6-2190bd90d7ea.webp",
      "image_media": {
        "alt_text": "Modern living room with a light blue sectional sofa, glass coffee table, and a plaid armchair.",
        "public_id": "019fb374-984d-74ba-acc6-2190bd90d7ea",
        "storage_key": "property/6737460151192634/019fb374-984d-74ba-acc6-2190bd90d7ea.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable sectional sofa, elegant coffee table, and a cozy armchair, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a light blue sectional sofa, glass coffee table, and a plaid armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b4f738a-9413-48cd-b99e-9cdc76a0cb69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-99ff-773f-a708-a2d236679933.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, window, and ceiling fan.",
        "public_id": "019fb374-99ff-773f-a708-a2d236679933",
        "storage_key": "property/6737460151192634/019fb374-99ff-773f-a708-a2d236679933.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, ample natural light, and modern furnishings.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, window, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d502c547-e593-426f-9d4e-d9e3c0325b79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-98b7-70cf-91e2-de2aff6d6bac.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and large mirror.",
        "public_id": "019fb374-98b7-70cf-91e2-de2aff6d6bac",
        "storage_key": "property/6737460151192634/019fb374-98b7-70cf-91e2-de2aff6d6bac.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with a yellow comforter, a classic dark wood nightstand, and a full-length mirror.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_84d5c949-dbd1-436e-986d-a66f95ad6adf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-97a3-7369-a18e-7ddde9cbc742.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with gray wood-look flooring and a white front door.",
        "public_id": "019fb374-97a3-7369-a18e-7ddde9cbc742",
        "storage_key": "property/6737460151192634/019fb374-97a3-7369-a18e-7ddde9cbc742.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this spacious apartment, featuring modern gray wood-look flooring and a welcoming entryway with a white front door. Perfect for creating your own comfortable living space.",
      "link": "",
      "alt_text": "Interior view of an empty apartment living room with gray wood-look flooring and a white front door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_103b34f5-e9bf-41c7-8d57-5e9abcb9e3d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-9737-774c-bae0-4ef0b0f76d64.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with ceiling fan and sliding glass door",
        "public_id": "019fb374-9737-774c-bae0-4ef0b0f76d64",
        "storage_key": "property/6737460151192634/019fb374-9737-774c-bae0-4ef0b0f76d64.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment bedroom featuring a ceiling fan and a sliding glass door leading to the outdoors.",
      "link": "",
      "alt_text": "Empty apartment bedroom with ceiling fan and sliding glass door",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b61a1f5-8ad9-4b56-8c7b-ec30643e87c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-979b-765e-acb9-dd9d3c7561d8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and walls, a ceiling fan, and a window.",
        "public_id": "019fb374-979b-765e-acb9-dd9d3c7561d8",
        "storage_key": "property/6737460151192634/019fb374-979b-765e-acb9-dd9d3c7561d8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting and a ceiling fan. Ample wall space provides opportunities for personalized decoration.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet and walls, a ceiling fan, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7348343a-84ee-4e3d-bb8d-f39ee0e58d72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-aa67-75b2-be77-52781f02b39f.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round table, four grey bar stools, and abstract wall art.",
        "public_id": "019e60e5-aa67-75b2-be77-52781f02b39f",
        "storage_key": "property/6737460151192634/019e60e5-aa67-75b2-be77-52781f02b39f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining experience in this modern apartment featuring a round table set for four and chic bar stools, complemented by striking wall art.",
      "link": "",
      "alt_text": "Modern dining area with a round table, four grey bar stools, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ca41ed13-c1d7-4bbe-a97c-6b942a082c12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-aa6a-71de-bcb8-9b19829af3da.webp",
      "image_media": {
        "alt_text": "Bathtub and toilet in a bathroom with a patterned shower curtain.",
        "public_id": "019e60e5-aa6a-71de-bcb8-9b19829af3da",
        "storage_key": "property/6737460151192634/019e60e5-aa6a-71de-bcb8-9b19829af3da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom featuring a bathtub, toilet, and a decorative shower curtain for privacy and style.",
      "link": "",
      "alt_text": "Bathtub and toilet in a bathroom with a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2b16a3e-d6dc-4ac3-b5c9-55e643b8327e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-9d69-7218-88aa-a2d67c1b9f91.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop, white sink, and chrome faucet. Features a large mirror with a vanity light fixture above.",
        "public_id": "019e60e5-9d69-7218-88aa-a2d67c1b9f91",
        "storage_key": "property/6737460151192634/019e60e5-9d69-7218-88aa-a2d67c1b9f91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Refreshing and clean bathroom featuring a vanity with ample counter space and a well-lit mirror, perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom vanity with granite countertop, white sink, and chrome faucet. Features a large mirror with a vanity light fixture above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3244ecfe-f0e4-489c-8ebe-fc49eec1107b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-88e9-738f-9fbd-95f2f301e324.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, gray subway tile backsplash, black appliances, and granite countertops.",
        "public_id": "019e60e5-88e9-738f-9fbd-95f2f301e324",
        "storage_key": "property/6737460151192634/019e60e5-88e9-738f-9fbd-95f2f301e324.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully updated kitchen featuring sleek white cabinetry, a stylish gray subway tile backsplash, and durable granite countertops. This space includes a full suite of black appliances and ample storage.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, gray subway tile backsplash, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56ebf60b-b425-4b0a-a467-da43b7f0bf25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-70e8-777c-bb70-541c00af652d.webp",
      "image_media": {
        "alt_text": "Empty closet with shelf and hangers",
        "public_id": "019e60e5-70e8-777c-bb70-541c00af652d",
        "storage_key": "property/6737460151192634/019e60e5-70e8-777c-bb70-541c00af652d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with shelving and hangers, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with shelf and hangers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83e88282-b75b-4c32-a635-c9fd9f34bdae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-6815-77ff-a32f-7d894d9fed7f.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a bench.",
        "public_id": "019e60e5-6815-77ff-a32f-7d894d9fed7f",
        "storage_key": "property/6737460151192634/019e60e5-6815-77ff-a32f-7d894d9fed7f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community offers a dedicated dog park with agility equipment, perfect for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e41a1634-c743-4fb3-8543-d19b538e65c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-4559-761f-a178-6f30df3704a3.webp",
      "image_media": {
        "alt_text": "Picnic table with umbrella in grassy area with apartment buildings in background.",
        "public_id": "019e60e5-4559-761f-a178-6f30df3704a3",
        "storage_key": "property/6737460151192634/019e60e5-4559-761f-a178-6f30df3704a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation at our community's picnic area, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Picnic table with umbrella in grassy area with apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14dc6890-5891-4b17-bee8-8090f5f183a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-48f3-74e9-8395-7fbe22fbbd8b.webp",
      "image_media": {
        "alt_text": "Building 201 entrance with red doors and shutters.",
        "public_id": "019e60e5-48f3-74e9-8395-7fbe22fbbd8b",
        "storage_key": "property/6737460151192634/019e60e5-48f3-74e9-8395-7fbe22fbbd8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The welcoming entrance to Building 201, featuring vibrant red doors and classic shutters.",
      "link": "",
      "alt_text": "Building 201 entrance with red doors and shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39e6b798-f0bc-4380-84d1-1f8908b3e9ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-43db-745a-a1ca-55a561fb0707.webp",
      "image_media": {
        "alt_text": "Exterior of building 204 with red door and shutters.",
        "public_id": "019e60e5-43db-745a-a1ca-55a561fb0707",
        "storage_key": "property/6737460151192634/019e60e5-43db-745a-a1ca-55a561fb0707.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to building 204, featuring a bright red door and charming red shutters. Surrounded by lush greenery, this building offers a welcoming entrance to the community.",
      "link": "",
      "alt_text": "Exterior of building 204 with red door and shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ab23ff5-cc76-4f3c-b802-aca24628e42b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-40f2-741a-9adb-92b04e321425.webp",
      "image_media": {
        "alt_text": "Carriage House Apartment Homes property signage and entrance with palm trees and landscaping.",
        "public_id": "019e60e5-40f2-741a-9adb-92b04e321425",
        "storage_key": "property/6737460151192634/019e60e5-40f2-741a-9adb-92b04e321425.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Carriage House Apartment Homes, featuring beautiful landscaping and a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Carriage House Apartment Homes property signage and entrance with palm trees and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a0e59c5-4e12-414f-b608-f0bc0de1e0be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-3db7-7674-bc44-8d7164aaea6d.webp",
      "image_media": {
        "alt_text": "Playground with swings and a slide.",
        "public_id": "019e60e5-3db7-7674-bc44-8d7164aaea6d",
        "storage_key": "property/6737460151192634/019e60e5-3db7-7674-bc44-8d7164aaea6d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with swings and a colorful slide for endless entertainment.",
      "link": "",
      "alt_text": "Playground with swings and a slide.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff254352-aba3-4d21-99fc-4724fc395732",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-3604-7251-8fc4-55327fc5b191.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a built-in grill and a picnic table with an umbrella.",
        "public_id": "019e60e5-3604-7251-8fc4-55327fc5b191",
        "storage_key": "property/6737460151192634/019e60e5-3604-7251-8fc4-55327fc5b191.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining at our community grilling station, complete with a stainless steel grill and a shaded picnic area for gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling station with a built-in grill and a picnic table with an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bcb77ed-5e3a-4ab8-b76f-ab8256516abc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-30df-726e-8c30-0891233d6a1d.webp",
      "image_media": {
        "alt_text": "Sidewalks winding through a manicured lawn in front of brick apartment buildings.",
        "public_id": "019e60e5-30df-726e-8c30-0891233d6a1d",
        "storage_key": "property/6737460151192634/019e60e5-30df-726e-8c30-0891233d6a1d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stroll along the scenic walkways surrounded by lush green lawns and mature trees, leading to your apartment home.",
      "link": "",
      "alt_text": "Sidewalks winding through a manicured lawn in front of brick apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce83f6a6-ba25-48ac-9537-6f8da7463151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-070d-7718-bde5-f980343d0a63.webp",
      "image_media": {
        "alt_text": "Building exterior with two red doors and shutters.",
        "public_id": "019e60e5-070d-7718-bde5-f980343d0a63",
        "storage_key": "property/6737460151192634/019e60e5-070d-7718-bde5-f980343d0a63.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring red doors, shutters, and lush green landscaping.",
      "link": "",
      "alt_text": "Building exterior with two red doors and shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e75d7898-b587-4944-95f9-cd084b4738cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-0b35-7120-9703-9047a0870d53.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with red doors and shutters.",
        "public_id": "019e60e5-0b35-7120-9703-9047a0870d53",
        "storage_key": "property/6737460151192634/019e60e5-0b35-7120-9703-9047a0870d53.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming brick apartment building with bright red doors and shutters, surrounded by lush greenery and mature trees. Offers a welcoming exterior for residents.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with red doors and shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dee9bc4f-4946-4544-ac61-9fe236a27288",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-0cd1-706d-8442-fc1ba87e61b1.webp",
      "image_media": {
        "alt_text": "Exterior of building 202 with red shutters and a red door.",
        "public_id": "019e60e5-0cd1-706d-8442-fc1ba87e61b1",
        "storage_key": "property/6737460151192634/019e60e5-0cd1-706d-8442-fc1ba87e61b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to building 202, featuring charming red shutters and a vibrant red door, set amidst lush landscaping. Experience comfortable living in a beautiful community setting.",
      "link": "",
      "alt_text": "Exterior of building 202 with red shutters and a red door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2707fd8c-da75-4183-9c47-67efd3af0b1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-0f8c-75f9-aac0-efdf47e4f18b.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with manicured bushes and a concrete walkway.",
        "public_id": "019e60e5-0f8c-75f9-aac0-efdf47e4f18b",
        "storage_key": "property/6737460151192634/019e60e5-0f8c-75f9-aac0-efdf47e4f18b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior view of brick apartment buildings, surrounded by lush green landscaping and a winding concrete walkway.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with manicured bushes and a concrete walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dd97b62-ec06-45e5-a1e1-b7d7c73848b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e60e5-09c9-75f7-a03d-daded6fb9706.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with brick accents and red doors.",
        "public_id": "019e60e5-09c9-75f7-a03d-daded6fb9706",
        "storage_key": "property/6737460151192634/019e60e5-09c9-75f7-a03d-daded6fb9706.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a brick facade, second-story balconies with plants, and brightly painted red doors for a welcoming entrance.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with brick accents and red doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_87302130-c6d5-4500-b4db-c435aef30894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019fb374-9813-7369-aae9-6ec1694ff923.webp",
      "image_media": {
        "alt_text": "Children's playground with swings and slides.",
        "public_id": "019fb374-9813-7369-aae9-6ec1694ff923",
        "storage_key": "property/6737460151192634/019fb374-9813-7369-aae9-6ec1694ff923.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides and swings for endless entertainment.",
      "link": "",
      "alt_text": "Children's playground with swings and slides.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b53a4889-4a05-4fab-b85c-d40cad2df250",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Hirano's",
      "poi_type": "Restaurants",
      "poi_address": "4426 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Informal operation turning out Japanese dishes cooked on teppanyaki grills, plus specialty sushi.",
      "poi_long_description": "Informal operation turning out Japanese dishes cooked on teppanyaki grills, plus specialty sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-5d43-7557-913a-c6778f788f53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-5d43-7557-913a-c6778f788f53",
        "storage_key": "property/6737460151192634/019e1de6-5d43-7557-913a-c6778f788f53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://hiranoshabersham.com/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1758341365139208488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiranos",
      "poi_latitude": "32.0371075",
      "poi_longitude": "-81.1024107",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-353-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3fkB4x1-4gRKHn_zifiZhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_90dd01ca-c831-4ab8-ae62-f2478b1eb4c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The 5 Spot Midtown - Neighborhood Kitchen and Bar",
      "poi_type": "Restaurants",
      "poi_address": "4430 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Neighborhood eatery offering easygoing American bites like fried green tomatoes, burgers & fried chicken, plus happy hours.",
      "poi_long_description": "Neighborhood eatery offering easygoing American bites like fried green tomatoes, burgers & fried chicken, plus happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-610e-739b-8a9b-57ea04dfd0ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-610e-739b-8a9b-57ea04dfd0ad",
        "storage_key": "property/6737460151192634/019e1de6-610e-739b-8a9b-57ea04dfd0ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://5spotmidtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15143125938885346583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5-spot-midtown---neighborhood-kitchen-and-bar",
      "poi_latitude": "32.0369735",
      "poi_longitude": "-81.1024068",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-777-3021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWRGBYx1-4gRF8VDSM8wJ9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f8c64d15-a408-44a3-8828-c0482e7cdc48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Bella's Italian Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4420 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Extensive Italian menu (from pizza to scampi) in a casual, family-run setting with a long wine list.",
      "poi_long_description": "Extensive Italian menu (from pizza to scampi) in a casual, family-run setting with a long wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-61fb-7548-99af-78a63b21f176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-61fb-7548-99af-78a63b21f176",
        "storage_key": "property/6737460151192634/019e1de6-61fb-7548-99af-78a63b21f176.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bellascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11676719718397002262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellas-italian-cafe",
      "poi_latitude": "32.0372572",
      "poi_longitude": "-81.1023721",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-354-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSdYD4x1-4gRFkLazLcKDKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_de99d631-ab93-4c96-8495-447ddd86872e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Coffee Deli",
      "poi_type": "Restaurants",
      "poi_address": "4517 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed coffee shop set inside the Habersham Shopping Center in Midtown's Lamara Heights neighborhood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-604e-76cc-917c-09a0830195b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-604e-76cc-917c-09a0830195b7",
        "storage_key": "property/6737460151192634/019e1de6-604e-76cc-917c-09a0830195b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.savannahcoffeedeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7627458430010409658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coffee-deli",
      "poi_latitude": "32.036266",
      "poi_longitude": "-81.10305029999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-352-7818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d724-749b-a425-4a0da3f0667c",
        "storage_key": "property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJd9JFIIx1-4gRukLUswct2mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_67579481-f312-4d5e-8b6a-8d3dda806f29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Colleagues & Lovers",
      "poi_type": "Restaurants",
      "poi_address": "4523 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-610d-7582-a6b0-2fea29c3bb8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-610d-7582-a6b0-2fea29c3bb8f",
        "storage_key": "property/6737460151192634/019e1de6-610d-7582-a6b0-2fea29c3bb8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.colleaguesandlovers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9955173813533710510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colleagues--lovers",
      "poi_latitude": "32.0361316",
      "poi_longitude": "-81.1032512",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-999-6582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYhFVNp1-4gRrpjysNbhJ4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_be0f2c9a-52ed-485b-9ec9-f8587fd40ff1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Ardsley Station",
      "poi_type": "Restaurants",
      "poi_address": "102 E Victory Dr, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed eatery featuring Southern comfort foods, a bar and a patio, plus occasional live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-5cba-75e5-8130-e4c6fb834fea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-5cba-75e5-8130-e4c6fb834fea",
        "storage_key": "property/6737460151192634/019e1de6-5cba-75e5-8130-e4c6fb834fea.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://ardsleystation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15023779327112708103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ardsley-station",
      "poi_latitude": "32.05248720000001",
      "poi_longitude": "-81.10036319999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-777-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcyctAyf-4gRBwBp2LIvf9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0af35f81-5b84-4934-9c1e-95f5d39a4023",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Café Taureau",
      "poi_type": "Restaurants",
      "poi_address": "3129 Bull St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-5db2-701a-b333-e6042831bf63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-5db2-701a-b333-e6042831bf63",
        "storage_key": "property/6737460151192634/019e1de6-5db2-701a-b333-e6042831bf63.webp",
        "width": 512,
        "height": 640
      },
      "poi_business_url": "https://cafetaureau.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2353510269801179367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-taureau",
      "poi_latitude": "32.0489353",
      "poi_longitude": "-81.1036642",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-482-0521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d724-749b-a425-4a0da3f0667c",
        "storage_key": "property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ09plu_Of-4gR56i79h5ZqSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_04935024-6caf-46bc-a32f-30e4106eb790",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Foxy Loxy Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1919 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Stylish coffee shop with a menu of Tex-Mex fare, beer & wine, plus art displays & outdoor seating.",
      "poi_long_description": "Stylish coffee shop with a menu of Tex-Mex fare, beer & wine, plus art displays & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-5d39-755a-8b2e-0ef095f02779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-5d39-755a-8b2e-0ef095f02779",
        "storage_key": "property/6737460151192634/019e1de6-5d39-755a-8b2e-0ef095f02779.webp",
        "width": 1280,
        "height": 542
      },
      "poi_business_url": "https://www.foxyloxycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11390000424011381902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foxy-loxy-cafe",
      "poi_latitude": "32.058364",
      "poi_longitude": "-81.099987",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-401-0543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d724-749b-a425-4a0da3f0667c",
        "storage_key": "property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJjUC6CLuf-4gRjjy_8AlpEZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_4f5b1d1f-284d-48e6-96ea-d63d66c47097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The Grey",
      "poi_type": "Restaurants",
      "poi_address": "109 Martin Luther King Jr Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Upscale restaurant serving Southern fare and small plates in a historic setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6783-73db-be74-5787ce21a1e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6783-73db-be74-5787ce21a1e5",
        "storage_key": "property/6737460151192634/019e1de6-6783-73db-be74-5787ce21a1e5.webp",
        "width": 1280,
        "height": 974
      },
      "poi_business_url": "http://www.thegreyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=509463294849771541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grey",
      "poi_latitude": "32.0798625",
      "poi_longitude": "-81.0976641",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-662-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRtZgV2e-4gRFeie2yr6EQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e4d63176-5635-4dcd-a27e-50f3d6ecf5bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The Olde Pink House",
      "poi_type": "Restaurants",
      "poi_address": "23 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "Inventive Southern cuisine served in an elegant Colonial mansion & live music in the cellar tavern.",
      "poi_long_description": "Inventive Southern cuisine served in an elegant Colonial mansion & live music in the cellar tavern.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6179-734d-850d-c6db01aee48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6179-734d-850d-c6db01aee48e",
        "storage_key": "property/6737460151192634/019e1de6-6179-734d-850d-c6db01aee48e.webp",
        "width": 1004,
        "height": 1280
      },
      "poi_business_url": "http://theoldepinkhouserestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12064019809664313211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olde-pink-house",
      "poi_latitude": "32.0796149",
      "poi_longitude": "-81.0898033",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-232-4286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQpbUGSe-4gReydRVhkCbKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_22553c4f-1b53-45f9-a1a0-b8b3aa5c6c24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Mrs. Wilkes Dining Room",
      "poi_type": "Restaurants",
      "poi_address": "107 W Jones St, Savannah, GA 31401, USA",
      "poi_short_description": "Family-owned since 1943, this busy Southern diner serves ample lunches to guests at communal tables.",
      "poi_long_description": "Family-owned since 1943, this busy Southern diner serves ample lunches to guests at communal tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6a97-7499-b9a4-112938e6803b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6a97-7499-b9a4-112938e6803b",
        "storage_key": "property/6737460151192634/019e1de6-6a97-7499-b9a4-112938e6803b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mrswilkes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13458310307102477254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mrs-wilkes-dining-room",
      "poi_latitude": "32.0726524",
      "poi_longitude": "-81.0959663",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-qgvGme-4gRxkvSS-uFxbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0111ac3e-6264-41bb-b198-22c11433fe2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The Collins Quarter",
      "poi_type": "Restaurants",
      "poi_address": "151 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Combination of bar, cafe, and restaurant serving espresso drinks, beer, wine, and Australian-accented meals.",
      "poi_long_description": "Combination of bar, cafe, and restaurant serving espresso drinks, beer, wine, and Australian-accented meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6cdb-7218-a4e4-07e9f3eecb38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6cdb-7218-a4e4-07e9f3eecb38",
        "storage_key": "property/6737460151192634/019e1de6-6cdb-7218-a4e4-07e9f3eecb38.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thecollinsquarter.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4905887690237642877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-collins-quarter",
      "poi_latitude": "32.0771863",
      "poi_longitude": "-81.092806",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-777-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7q2D2ae-4gRfYiTnNw2FUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d413d9ce-3cd8-4529-8d2a-b388229dd0e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The Sentient Bean",
      "poi_type": "Restaurants",
      "poi_address": "13 E Park Ave, Savannah, GA 31401, USA",
      "poi_short_description": "Airy space with high ceilings starring fair-trade coffee & vegetarian chow, plus art & live music.",
      "poi_long_description": "Airy space with high ceilings starring fair-trade coffee & vegetarian chow, plus art & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-69a5-7728-ac4b-5c7dca187487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-69a5-7728-ac4b-5c7dca187487",
        "storage_key": "property/6737460151192634/019e1de6-69a5-7728-ac4b-5c7dca187487.webp",
        "width": 768,
        "height": 960
      },
      "poi_business_url": "http://sentientbean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13219978477699712036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-sentient-bean",
      "poi_latitude": "32.0645916",
      "poi_longitude": "-81.0970129",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-232-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d724-749b-a425-4a0da3f0667c",
        "storage_key": "property/6737460151192634/019e1de6-d724-749b-a425-4a0da3f0667c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJsfR4RxWe-4gRJMSZDWLMdrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_16e18208-991d-4e66-be26-13acfadd386d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Common Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "118 E Broughton St, Savannah, GA 31401, USA",
      "poi_short_description": "Industrial-chic venue popular for its brunch, oyster bar, and cocktails, plus happy-hour specials.",
      "poi_long_description": "Industrial-chic venue popular for its brunch, oyster bar, and cocktails, plus happy-hour specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7b57-71db-b1bc-dd59def8e06c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7b57-71db-b1bc-dd59def8e06c",
        "storage_key": "property/6737460151192634/019e1de6-7b57-71db-b1bc-dd59def8e06c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.commonrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12105033568613343628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "common-restaurant",
      "poi_latitude": "32.0786446",
      "poi_longitude": "-81.0901992",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-777-3742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1phcsmf-4gRjKFgO-W3_ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_893d273d-d99f-4cda-ab6e-8fb75a78f345",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Vic's On the River",
      "poi_type": "Restaurants",
      "poi_address": "26 E Bay St, Savannah, GA 31401, USA",
      "poi_short_description": "This fine-dining restaurant in a 19th-century warehouse features classic Southern cooking.",
      "poi_long_description": "This fine-dining restaurant in a 19th-century warehouse features classic Southern cooking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6c64-7082-a3fe-e5a9139153fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6c64-7082-a3fe-e5a9139153fc",
        "storage_key": "property/6737460151192634/019e1de6-6c64-7082-a3fe-e5a9139153fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vicsontheriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7196230059270299891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vics-on-the-river",
      "poi_latitude": "32.08123550000001",
      "poi_longitude": "-81.0903189",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-721-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b691-7011-8e34-deee4385bf30",
        "storage_key": "property/6737460151192634/019e1de4-b691-7011-8e34-deee4385bf30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJofzkcWSe-4gR82DLlBwl3mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b17c0338-d8be-4697-8ca7-d150f136ccd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "La Tapatia Productos Latinos",
      "poi_type": "Shopping & Retail",
      "poi_address": "5548 Ogeechee Rd Suite I, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6bad-7004-959a-f47a3334de6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6bad-7004-959a-f47a3334de6e",
        "storage_key": "property/6737460151192634/019e1de6-6bad-7004-959a-f47a3334de6e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10426886887355229162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tapatia-productos-latinos",
      "poi_latitude": "32.0380274",
      "poi_longitude": "-81.21437809999999",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-238-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6c4-777c-a56a-f646e2e8e7af",
        "storage_key": "property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyduukWQK-4gR6qP8SWG-s5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e4891159-ea63-43c6-bdd0-8bcf4f14e4e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Tibet Liquor",
      "poi_type": "Shopping & Retail",
      "poi_address": "112 Tibet Ave, Savannah, GA 31406, USA",
      "poi_short_description": "Liquor shop offering a quick-visit shopping experience.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-70df-725a-9cb1-5eb0d78d6cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-70df-725a-9cb1-5eb0d78d6cb3",
        "storage_key": "property/6737460151192634/019e1de6-70df-725a-9cb1-5eb0d78d6cb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://facebook.com/tibetliquor",
      "poi_directions_map_url": "https://maps.google.com/?cid=2082993383827263698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tibet-liquor",
      "poi_latitude": "31.989634",
      "poi_longitude": "-81.1317337",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 912-201-1338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b692-7256-b7e3-fbf8a508e96f",
        "storage_key": "property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9dBJXeV0-4gR0lCDSHJH6Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_1117237c-6c34-4547-a7f0-d05bdbe7be46",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Sunoco",
      "poi_type": "Shopping & Retail",
      "poi_address": "7361 Skidaway Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Chain gas station offering diesel, and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-6f28-75a3-a73c-146e383c5db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-6f28-75a3-a73c-146e383c5db3",
        "storage_key": "property/6737460151192634/019e1de6-6f28-75a3-a73c-146e383c5db3.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15649962366588558367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "31.9859509",
      "poi_longitude": "-81.0746131",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-354-2989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d732-77f9-91f4-7b2be47cb906.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d732-77f9-91f4-7b2be47cb906",
        "storage_key": "property/6737460151192634/019e1de6-d732-77f9-91f4-7b2be47cb906.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-Rsv4J2-4gRHxy--NrVL9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_b1fc3cdc-74f1-4747-ad42-8e4b646d770a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "2208 E Derenne Ave, Savannah, GA 31406, USA",
      "poi_short_description": "Chain grocery store offering bulk foods, organic items, and prepared eats, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7495-7464-ad01-43d62973cd99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7495-7464-ad01-43d62973cd99",
        "storage_key": "property/6737460151192634/019e1de6-7495-7464-ad01-43d62973cd99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/ga/savannah/2208-e-derenne-ave?y_source=1_NTA0Njg2Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10089309951936465640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.0194043",
      "poi_longitude": "-81.073021",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-356-1274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6c4-777c-a56a-f646e2e8e7af",
        "storage_key": "property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9MduAp2-4gR6Ir8IfJtBIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_78ef3ae1-7b82-4530-80af-9c77168f68e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Publix Super Market at The Village on Skidaway Island",
      "poi_type": "Shopping & Retail",
      "poi_address": "6 W Ridge Rd, Savannah, GA 31411, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-75ef-74eb-b394-752ec6090e6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-75ef-74eb-b394-752ec6090e6d",
        "storage_key": "property/6737460151192634/019e1de6-75ef-74eb-b394-752ec6090e6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1489&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=14183252169338692101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-village-on-skidaway-island",
      "poi_latitude": "31.940082",
      "poi_longitude": "-81.0504919",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-598-3130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6c4-777c-a56a-f646e2e8e7af",
        "storage_key": "property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RsYNDdx-4gRBaI4sbMI1cQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_bc6b70a5-cde1-4ec8-8cb9-26901fa825fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "14030 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Family-friendly department store selling electronics, toys and home essentials, plus food items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-77bf-709a-b4e4-0ceb8460b9c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-77bf-709a-b4e4-0ceb8460b9c9",
        "storage_key": "property/6737460151192634/019e1de6-77bf-709a-b4e4-0ceb8460b9c9.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4556-savannah-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3025937250404695763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.9808092",
      "poi_longitude": "-81.17354399999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-344-9664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b692-7256-b7e3-fbf8a508e96f",
        "storage_key": "property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnXrDxjcL-4gR037-quVJ_ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ba63c6a7-af3d-47a8-8173-65903dd78256",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5401 Abercorn St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-776d-740b-9b75-7e3c62851887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-776d-740b-9b75-7e3c62851887",
        "storage_key": "property/6737460151192634/019e1de6-776d-740b-9b75-7e3c62851887.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/savannah-ga-pharmacies/5401-abercorn-st-corner-of-derenne-ave-savannah-ga-31405/storeid=5520?WT.mc_id=LS_GOOGLE_RX_5520",
      "poi_directions_map_url": "https://maps.google.com/?cid=179128012207649309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.02804",
      "poi_longitude": "-81.109127",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-356-3170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d743-7579-8e09-12617377cced.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d743-7579-8e09-12617377cced",
        "storage_key": "property/6737460151192634/019e1de6-d743-7579-8e09-12617377cced.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxN6Dpp1-4gRHXL1YPpjfAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4ec7863e-3475-4b51-bb37-531e104a72f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 E Derenne Ave, Savannah, GA 31405, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7a85-7019-9635-1f316a185541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7a85-7019-9635-1f316a185541",
        "storage_key": "property/6737460151192634/019e1de6-7a85-7019-9635-1f316a185541.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-700+e+derenne+ave-savannah-ga-31405/id=2171",
      "poi_directions_map_url": "https://maps.google.com/?cid=9973255401728783760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.0257602",
      "poi_longitude": "-81.09719199999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-354-4853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb454rpR1-4gRkDVKgvIeaIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_4432b71d-bcd8-42cb-8bba-e9d44e66fb30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Largo-Tibet Elementary School",
      "poi_type": "Education",
      "poi_address": "430 Tibet Ave, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/lt/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497584999114004779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "largo-tibet-elementary-school",
      "poi_latitude": "31.9930934",
      "poi_longitude": "-81.14056029999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3QkQUOZ0-4gRK9nskwbriTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4d0ed791-17b8-4314-a4d0-7d040648d11e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Providence Christian School",
      "poi_type": "Education",
      "poi_address": "401 Tibet Ave, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13731551122924510568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-christian-school",
      "poi_latitude": "31.9910681",
      "poi_longitude": "-81.139408",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-335-7976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQZkR7dp0-4gRaB0IUf5EkL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_222f3fd8-78a4-4b43-9a48-3a2a6371a3a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "SSA Savannah United Soccer Academy",
      "poi_type": "Education",
      "poi_address": "Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7a9a-73b7-8c94-b415d8c6c60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7a9a-73b7-8c94-b415d8c6c60c",
        "storage_key": "property/6737460151192634/019e1de6-7a9a-73b7-8c94-b415d8c6c60c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.savannahunited.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15896061026608770807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ssa-savannah-united-soccer-academy",
      "poi_latitude": "32.0020498",
      "poi_longitude": "-81.09424410000001",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-691-2472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzD_yMt1-4gR927yYkgnmtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_ae221409-7c62-4d6c-8344-af89455decad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Herschel V Jenkins High School",
      "poi_type": "Education",
      "poi_address": "1800 E Derenne Ave, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://jenkins.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14700207686435644468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herschel-v-jenkins-high-school",
      "poi_latitude": "32.023494",
      "poi_longitude": "-81.0834799",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-395-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd_cMD-d1-4gRNKR2egGhAcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3e1ffd0d-db89-4e76-8b44-c8e71290cce2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Benedictine Military School",
      "poi_type": "Education",
      "poi_address": "6502 Seawright Dr, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7f55-73e3-bfc4-240093772449.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7f55-73e3-bfc4-240093772449",
        "storage_key": "property/6737460151192634/019e1de6-7f55-73e3-bfc4-240093772449.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebc400.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=811578037580285650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benedictine-military-school",
      "poi_latitude": "32.0095082",
      "poi_longitude": "-81.0924636",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsfVTNMZ1-4gR0kZ73exNQws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5bd13a1b-0e94-4224-be1e-1d08b0ada9a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Poetter Hall",
      "poi_type": "Education",
      "poi_address": "342 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Student art exhibits & a gift shop in a historic building at the Savannah College of Art & Design.",
      "poi_long_description": "Student art exhibits & a gift shop in a historic building at the Savannah College of Art & Design.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7c10-729c-a379-4f7ae56b1ab7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7c10-729c-a379-4f7ae56b1ab7",
        "storage_key": "property/6737460151192634/019e1de6-7c10-729c-a379-4f7ae56b1ab7.webp",
        "width": 1170,
        "height": 659
      },
      "poi_business_url": "https://www.scad.edu/life/buildings-and-facilities/poetter-hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14011371275290306160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poetter-hall",
      "poi_latitude": "32.0729937",
      "poi_longitude": "-81.0940406",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_U6-D2me-4gRcGbKf_BjcsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7ba5ae26-5439-467d-baab-7deb4038af77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Technical College",
      "poi_type": "Education",
      "poi_address": "5717 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-7f83-71fe-8d0c-e08d7c698fb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-7f83-71fe-8d0c-e08d7c698fb9",
        "storage_key": "property/6737460151192634/019e1de4-7f83-71fe-8d0c-e08d7c698fb9.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "https://www.savannahtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7052498624589095008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-technical-college",
      "poi_latitude": "32.0235786",
      "poi_longitude": "-81.1141815",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-443-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdS0rI591-4gRYGCQISKC32E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e9c82538-9bcc-4c32-8e17-632732021348",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Montessori Academy of Savannah, Inc.",
      "poi_type": "Education",
      "poi_address": "8415 Cresthill Ave, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://families.decal.ga.gov/ChildCare/detail/2064",
      "poi_directions_map_url": "https://maps.google.com/?cid=8959555476559668974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-academy-of-savannah-inc",
      "poi_latitude": "31.9913076",
      "poi_longitude": "-81.0963922",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-355-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxBVbTZ0-4gR7qa-dTy8Vnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d34a575d-82a7-40aa-996f-d3cfe975165f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "SCAD Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "601 Turner Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_long_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7fbf-772d-8868-9e72931663a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7fbf-772d-8868-9e72931663a1",
        "storage_key": "property/6737460151192634/019e1de6-7fbf-772d-8868-9e72931663a1.webp",
        "width": 992,
        "height": 557
      },
      "poi_business_url": "https://www.scadmoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079924297740066703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scad-museum-of-art",
      "poi_latitude": "32.0775935",
      "poi_longitude": "-81.0994025",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-525-7191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2I9T12e-4gRjx-gOb4V44s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_82310a3a-f7de-42b5-922a-e5f7777bcea0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Telfair Academy",
      "poi_type": "Entertainment",
      "poi_address": "121 Barnard St, Savannah, GA 31401, USA",
      "poi_short_description": "Part of oldest public art museum in the South, housing 19th- & 20th-century American & European art.",
      "poi_long_description": "Part of oldest public art museum in the South, housing 19th- & 20th-century American & European art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-807f-761e-86da-593907cc0b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-807f-761e-86da-593907cc0b7b",
        "storage_key": "property/6737460151192634/019e1de6-807f-761e-86da-593907cc0b7b.webp",
        "width": 1280,
        "height": 1093
      },
      "poi_business_url": "http://www.telfair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5508070588414779472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "telfair-academy",
      "poi_latitude": "32.0789347",
      "poi_longitude": "-81.09531",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRUGA9ZASZcEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b89a3e6d-69aa-46e7-8ade-158ebcf7639b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Jepson Center & Telfair Children's Art Museum (CAM)",
      "poi_type": "Entertainment",
      "poi_address": "207 W York St, Savannah, GA 31401, USA",
      "poi_short_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_long_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-819f-757a-ae83-8afc92d10a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-819f-757a-ae83-8afc92d10a77",
        "storage_key": "property/6737460151192634/019e1de6-819f-757a-ae83-8afc92d10a77.webp",
        "width": 1280,
        "height": 1001
      },
      "poi_business_url": "http://www.telfair.org/visit/jepson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733686102627315117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jepson-center--telfair-childrens-art-museum-cam",
      "poi_latitude": "32.0782855",
      "poi_longitude": "-81.0951522",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRre39-dn-Oeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_94cd18b6-0eef-4b83-a0ba-ae7abf533ba4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Theatre",
      "poi_type": "Entertainment",
      "poi_address": "222 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_long_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-81ee-758f-82d3-551a822a4546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-81ee-758f-82d3-551a822a4546",
        "storage_key": "property/6737460151192634/019e1de6-81ee-758f-82d3-551a822a4546.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12411390908795783721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-theatre",
      "poi_latitude": "32.0758167",
      "poi_longitude": "-81.0924435",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-233-7764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTqMrmie-4gRKQpJ70UePqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0ca9143a-17f5-4d70-ba1d-9587868cdd04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Lucas Theatre For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "32 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_long_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-86ac-76ec-84ee-3d9b6c17acc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-86ac-76ec-84ee-3d9b6c17acc3",
        "storage_key": "property/6737460151192634/019e1de6-86ac-76ec-84ee-3d9b6c17acc3.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "https://www.lucastheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14397539329963391563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucas-theatre-for-the-arts",
      "poi_latitude": "32.0788098",
      "poi_longitude": "-81.0892985",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-525-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQvlp2We-4gRS_ouOr1Vzsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3111e38d-66b5-4292-b443-87d2c6f27ed0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Ships Of The Sea Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "41 Martin Luther King Jr Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Ode to 18th- & 19th-century vessels in an 1819 home with a parlor garden & an event space.",
      "poi_long_description": "Ode to 18th- & 19th-century vessels in an 1819 home with a parlor garden & an event space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-88b0-749c-9167-282ef8877bce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-88b0-749c-9167-282ef8877bce",
        "storage_key": "property/6737460151192634/019e1de6-88b0-749c-9167-282ef8877bce.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.shipsofthesea.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649791718056594388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ships-of-the-sea-maritime-museum",
      "poi_latitude": "32.0811605",
      "poi_longitude": "-81.0972819",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-232-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlauZXWee-4gR1At9iAmFKWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_60129d8b-6f5e-4022-ae1d-4f97d4f4c8b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Owens-Thomas House & Slave Quarters",
      "poi_type": "Entertainment",
      "poi_address": "124 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "English Regency-style house museum from 1819, with parterre-style garden & original slave quarters.",
      "poi_long_description": "English Regency-style house museum from 1819, with parterre-style garden & original slave quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-88a0-742e-a3f7-d5e0c8f078c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-88a0-742e-a3f7-d5e0c8f078c7",
        "storage_key": "property/6737460151192634/019e1de6-88a0-742e-a3f7-d5e0c8f078c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.telfair.org/visit/owens-thomas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5864922328680630729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "owens-thomas-house--slave-quarters",
      "poi_latitude": "32.0773837",
      "poi_longitude": "-81.0892894",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48MqmWWe-4gRyQlExMhjZFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6e9fc1aa-2fab-4ae7-9515-a655b1df2a2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_long_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-8bc2-73cb-a135-9df6e55c9fb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-8bc2-73cb-a135-9df6e55c9fb2",
        "storage_key": "property/6737460151192634/019e1de6-8bc2-73cb-a135-9df6e55c9fb2.webp",
        "width": 827,
        "height": 1240
      },
      "poi_business_url": "http://www.chsgeorgia.org/SCM",
      "poi_directions_map_url": "https://maps.google.com/?cid=606148658374513045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-childrens-museum",
      "poi_latitude": "32.0760234",
      "poi_longitude": "-81.10093359999999",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RuwSlue-4gRlRF-R_54aQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2471bb09-867e-48c9-921b-d6d4e531a619",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Enmarket Arena",
      "poi_type": "Entertainment",
      "poi_address": "620 Stiles Ave, Savannah, GA 31415, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-8639-7651-97f4-23c4ce8c2b2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-8639-7651-97f4-23c4ce8c2b2d",
        "storage_key": "property/6737460151192634/019e1de4-8639-7651-97f4-23c4ce8c2b2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.enmarketarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9620920495736123832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enmarket-arena",
      "poi_latitude": "32.0740493",
      "poi_longitude": "-81.11158069999999",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-468-5177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzQLsxKf-4gRuHGgkDdghIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0a69cc20-839e-4a46-8b8f-af557f78f71f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "712 Stephenson Ave, Savannah, GA 31405, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-902d-741d-a7df-ebdb0dfd6d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-902d-741d-a7df-ebdb0dfd6d87",
        "storage_key": "property/6737460151192634/019e1de6-902d-741d-a7df-ebdb0dfd6d87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/savannah-ga-pharmacies/712-stephenson-ave-savannah-ga-31405/storeid=4257?WT.mc_id=LS_GOOGLE_FS_4257",
      "poi_directions_map_url": "https://maps.google.com/?cid=17033906851489222734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.0106083",
      "poi_longitude": "-81.1002484",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-355-8601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzymsxrl1-4gRTpAbLAiYZOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_fd5695eb-ab8e-48a1-b792-ff530fc45841",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "700 E Derenne Ave, Savannah, GA 31405, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9465-724d-b89f-0c393f1dab23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9465-724d-b89f-0c393f1dab23",
        "storage_key": "property/6737460151192634/019e1de6-9465-724d-b89f-0c393f1dab23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-700+e+derenne+ave-savannah-ga-31405/id=2171",
      "poi_directions_map_url": "https://maps.google.com/?cid=83601665603082645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.0257774",
      "poi_longitude": "-81.097177",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-354-4853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d743-7579-8e09-12617377cced.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d743-7579-8e09-12617377cced",
        "storage_key": "property/6737460151192634/019e1de6-d743-7579-8e09-12617377cced.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXzKgVut1-4gRlRnnnEUDKQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_aaad2d4d-3302-4cb3-8fd0-fcd3a2e78394",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Health and Wellness",
      "poi_address": "318 Mall Blvd Suite 100, Savannah, GA 31406, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-7182-713e-bf6b-70a1fa9c8c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-7182-713e-bf6b-70a1fa9c8c65",
        "storage_key": "property/6737460151192634/019e1de6-7182-713e-bf6b-70a1fa9c8c65.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/savannah/savannah-marketwalk/011/00697?cid=loc_01100697_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15465656371393964293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "32.0063117",
      "poi_longitude": "-81.112933",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-200-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6c4-777c-a56a-f646e2e8e7af",
        "storage_key": "property/6737460151192634/019e1de4-b6c4-777c-a56a-f646e2e8e7af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6V7_EKx1-4gRBakxe4cModY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6b46d507-f528-4f27-902d-1fec21470669",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 Eisenhower Dr, Savannah, GA 31406, USA",
      "poi_short_description": "Gym offering cardio equipment, free weights, tanning beds and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-8a66-7448-ae3a-1c2b76d0e096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-8a66-7448-ae3a-1c2b76d0e096",
        "storage_key": "property/6737460151192634/019e1de4-8a66-7448-ae3a-1c2b76d0e096.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/savannah-eisenhower-dr-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889146179196540397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.0083823",
      "poi_longitude": "-81.0990214",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-200-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYQNybd1-4gR7dV7tNwowMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b7802f13-877e-4f26-9d95-b1bf702e294c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "The ZOO Health Club Savannah",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Mall Way, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-914d-7639-84dd-989877dd9679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-914d-7639-84dd-989877dd9679",
        "storage_key": "property/6737460151192634/019e1de6-914d-7639-84dd-989877dd9679.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.zoogymsavannah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6512998031151290498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-zoo-health-club-savannah",
      "poi_latitude": "32.0015318",
      "poi_longitude": "-81.1138755",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-712-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1WVyzx1-4gRgliXtTPRYlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06866da9-c661-457d-a708-03b009254f31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "StretchLab",
      "poi_type": "Health and Wellness",
      "poi_address": "5525 Abercorn St Suite #90, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed, clean studio for one-on-one and group stretching services, plus demos and packages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-933d-747c-9f50-c18c93777a32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-933d-747c-9f50-c18c93777a32",
        "storage_key": "property/6737460151192634/019e1de6-933d-747c-9f50-c18c93777a32.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://local.stretchlab.com/location/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828985834247785036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stretchlab",
      "poi_latitude": "32.0241435",
      "poi_longitude": "-81.11211159999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-335-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRShW8p1-4gRTIqPBe3cYRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_4f3392b3-4632-4cdc-90f9-7fe0f2bacd39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "ExperCARE Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "818 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9776-726b-83e4-a43a9e4be0ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9776-726b-83e4-a43a9e4be0ce",
        "storage_key": "property/6737460151192634/019e1de6-9776-726b-83e4-a43a9e4be0ce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://expercarehealth.com/locations/savannah-downtown/?utm_source=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589221214307512956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expercare-urgent-care--primary-care",
      "poi_latitude": "32.0660604",
      "poi_longitude": "-81.0940409",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-800-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84elijGf-4gRfHLUHpd49JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_473376fa-6a2f-413e-8792-465ff6b56525",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Lake Mayer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1850 E Montgomery Cross Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Park with a lake offering picnic areas, a playground, tennis courts, and a skateboarding area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-a42d-76d9-bb63-bbfc4b0dfd66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-a42d-76d9-bb63-bbfc4b0dfd66",
        "storage_key": "property/6737460151192634/019e1de4-a42d-76d9-bb63-bbfc4b0dfd66.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/LakeMayer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999149330770112106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mayer-park",
      "poi_latitude": "31.992331",
      "poi_longitude": "-81.08626799999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc",
        "storage_key": "property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSN4wkl1-4gRai6Dcblnvhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8084bdd4-1d96-40a8-a613-69500556e9c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Daffin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E Victory Dr, Savannah, GA 31404, USA",
      "poi_short_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_long_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-ab9a-708e-b56a-d60f34a1dc7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-ab9a-708e-b56a-d60f34a1dc7a",
        "storage_key": "property/6737460151192634/019e1de4-ab9a-708e-b56a-d60f34a1dc7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/2957/Recreation-and-Leisure-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=10299007936776474142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daffin-park",
      "poi_latitude": "32.045328",
      "poi_longitude": "-81.0815665",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc",
        "storage_key": "property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeNjUQCe-4gRHo596iZt7Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a69a6f5a-31a0-4d2e-8117-853be833112d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Bacon Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Shorty Cooper Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Golf links offering a mix of holes and featuring a driving range and putting green.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-94a2-73d9-ac01-6cb00571d41c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-94a2-73d9-ac01-6cb00571d41c",
        "storage_key": "property/6737460151192634/019e1de6-94a2-73d9-ac01-6cb00571d41c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baconparkgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4019286711186714640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bacon-park-golf-course",
      "poi_latitude": "32.0066203",
      "poi_longitude": "-81.0819769",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-354-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d73a-728a-baf8-3de69d59cc09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d73a-728a-baf8-3de69d59cc09",
        "storage_key": "property/6737460151192634/019e1de6-d73a-728a-baf8-3de69d59cc09.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTdIHEcV1-4gREHC7_vdfxzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_714bffdf-4164-49aa-8418-1c3f6a6d95fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Wormsloe State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7601 Skidaway Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_long_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-850c-76d2-b04a-361294a755f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-850c-76d2-b04a-361294a755f0",
        "storage_key": "property/6737460151192634/019e1de4-850c-76d2-b04a-361294a755f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gastateparks.org/Wormsloe",
      "poi_directions_map_url": "https://maps.google.com/?cid=10012291246731543177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wormsloe-state-historic-site",
      "poi_latitude": "31.9801601",
      "poi_longitude": "-81.0692663",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-353-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Ccw5x2-4gRicIvbdfN8oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2900d8fd-c689-4a27-8abd-bdad8f2acef1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Oatland Island Wildlife Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "711 Sandtown Rd, Savannah, GA 31410, USA",
      "poi_short_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_long_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9904-7624-a78e-66a96b050c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9904-7624-a78e-66a96b050c83",
        "storage_key": "property/6737460151192634/019e1de6-9904-7624-a78e-66a96b050c83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oatland.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055131803854154654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oatland-island-wildlife-center",
      "poi_latitude": "32.049159",
      "poi_longitude": "-81.02449969999999",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-395-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc",
        "storage_key": "property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKz5cUG6d-4gRnqs9OYFuTKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_park"
    },
    {
      "id": "custom_a54ee332-b1e9-450e-8e99-8554e2f98c88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Forsyth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Savannah, GA 31401, USA",
      "poi_short_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_long_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-9f21-73a0-9829-fcf5c6c807e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-9f21-73a0-9829-fcf5c6c807e1",
        "storage_key": "property/6737460151192634/019e1de4-9f21-73a0-9829-fcf5c6c807e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/351/Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16070509674831716323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forsyth-park",
      "poi_latitude": "32.0675356",
      "poi_longitude": "-81.09623839999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc",
        "storage_key": "property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj52mkmqe-4gR45_Sb2frBd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c5771b6d-5af0-4ebd-9629-36d60f264a23",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Bonaventure Cemetery",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "330 Bonaventure Rd, Savannah, GA 31404, USA",
      "poi_short_description": "Tree-filled cemetery immortalized in best-selling \"Midnight in the Garden of Good and Evil\" novel.",
      "poi_long_description": "Tree-filled cemetery immortalized in best-selling \"Midnight in the Garden of Good and Evil\" novel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9de5-7428-bec7-22f5e6e9c3e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9de5-7428-bec7-22f5e6e9c3e0",
        "storage_key": "property/6737460151192634/019e1de6-9de5-7428-bec7-22f5e6e9c3e0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.savannahga.gov/Cemeteries",
      "poi_directions_map_url": "https://maps.google.com/?cid=16627136189079936711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonaventure-cemetery",
      "poi_latitude": "32.0452285",
      "poi_longitude": "-81.0506399",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-651-6843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d78d-778f-a3d1-b93080697c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d78d-778f-a3d1-b93080697c89",
        "storage_key": "property/6737460151192634/019e1de6-d78d-778f-a3d1-b93080697c89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJexSTgYyd-4gRx94mBkV0v-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cemetery"
    },
    {
      "id": "custom_69a83ee7-a654-49fb-bf78-fb6dfb8dd030",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Skidaway Island State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "52 Diamond Causeway, Savannah, GA 31411, USA",
      "poi_short_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_long_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-a3bf-753e-914a-0368bb4def44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-a3bf-753e-914a-0368bb4def44",
        "storage_key": "property/6737460151192634/019e1de4-a3bf-753e-914a-0368bb4def44.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gastateparks.org/SkidawayIsland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471744632454584550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skidaway-island-state-park",
      "poi_latitude": "31.95476559999999",
      "poi_longitude": "-81.0525755",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-598-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc",
        "storage_key": "property/6737460151192634/019e1de4-b6e1-72cb-b50a-9ea0c9f39cbc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TuGrZ2-4gR5hhn4Hhkl-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_447b6a7e-3cc8-48ae-850f-b7847c9e9f31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Fort Pulaski National Monument",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 Fort Pulaski Rd, Savannah, GA, USA",
      "poi_short_description": "Civil War landmark offering ranger tours & historic exhibits, plus riverside hiking & biking trails.",
      "poi_long_description": "Civil War landmark offering ranger tours & historic exhibits, plus riverside hiking & biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-990b-745d-a915-70a5ce98131b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-990b-745d-a915-70a5ce98131b",
        "storage_key": "property/6737460151192634/019e1de6-990b-745d-a915-70a5ce98131b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nps.gov/fopu/planyourvisit/hours.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=17754677739398651296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-pulaski-national-monument",
      "poi_latitude": "32.0271085",
      "poi_longitude": "-80.8904933",
      "poi_miles_from_property": "18.8",
      "poi_walking_minutes": "6 hours 54 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 912-226-4908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d76a-73b5-a766-5c04aaa2581c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d76a-73b5-a766-5c04aaa2581c",
        "storage_key": "property/6737460151192634/019e1de6-d76a-73b5-a766-5c04aaa2581c.webp",
        "width": 103,
        "height": 192
      },
      "poi_google_place_id": "ChIJFc9_9n-C-4gRoF1k7lVJZfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "monument"
    },
    {
      "id": "custom_8f8b0836-4697-4765-9c32-b3a73b080dab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Ogeechee Canal Museum and Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "681 Fort Argyle Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_long_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9e0d-705e-acc8-b3dfaa53d6a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9e0d-705e-acc8-b3dfaa53d6a0",
        "storage_key": "property/6737460151192634/019e1de6-9e0d-705e-acc8-b3dfaa53d6a0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahogeecheecanal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306472962369169396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-ogeechee-canal-museum-and-nature-center",
      "poi_latitude": "32.0231191",
      "poi_longitude": "-81.3167919",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-748-8068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6e4-71ae-a35e-b7e533ff9871",
        "storage_key": "property/6737460151192634/019e1de4-b6e4-71ae-a35e-b7e533ff9871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXT4FV0I-4gR9KdyDaTz4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b2bcfdef-076d-48eb-acaf-157c523fa1fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Joe Murray Rivers, Jr. Intermodal Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-990c-777f-ba74-ef1d967fb12e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-990c-777f-ba74-ef1d967fb12e",
        "storage_key": "property/6737460151192634/019e1de6-990c-777f-ba74-ef1d967fb12e.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901387300494243883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-murray-rivers-jr-intermodal-transit-center",
      "poi_latitude": "32.0795155",
      "poi_longitude": "-81.0998743",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d73e-738b-874e-cdabb42a7978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d73e-738b-874e-cdabb42a7978",
        "storage_key": "property/6737460151192634/019e1de6-d73e-738b-874e-cdabb42a7978.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6fx-Fye-4gRK_i97uJdp20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_4e2cf193-b97e-410c-921a-6cb233506661",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Greyhound Package Express",
      "poi_type": "Transportation & Transit",
      "poi_address": "610 W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9eef-73b2-8a3b-8fc04de1995f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9eef-73b2-8a3b-8fc04de1995f",
        "storage_key": "property/6737460151192634/019e1de6-9eef-73b2-8a3b-8fc04de1995f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10583998571183306292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-package-express",
      "poi_latitude": "32.0793576",
      "poi_longitude": "-81.1002123",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-739-5020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdOKA12e-4gRNHafwp_q4ZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_db7df4e2-92f9-47f0-b80a-3c33baf21c64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah",
      "poi_type": "Transportation & Transit",
      "poi_address": "2611 Seaboard Coastline Dr, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-9edc-7639-b8bd-65c5f59abc1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-9edc-7639-b8bd-65c5f59abc1d",
        "storage_key": "property/6737460151192634/019e1de6-9edc-7639-b8bd-65c5f59abc1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SAV",
      "poi_directions_map_url": "https://maps.google.com/?cid=1136550232795717085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah",
      "poi_latitude": "32.083701",
      "poi_longitude": "-81.1485479",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d781-737c-a9c2-d9b1079db93f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d781-737c-a9c2-d9b1079db93f",
        "storage_key": "property/6737460151192634/019e1de6-d781-737c-a9c2-d9b1079db93f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbNe15mf-4gR3R0tP2rWxQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_41df5545-6a56-4fc3-8cee-423f77504e5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Belles Ferry",
      "poi_type": "Transportation & Transit",
      "poi_address": "Savannah Belles Ferry, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-a4bc-777b-a38a-fbdc6e944de9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-a4bc-777b-a38a-fbdc6e944de9",
        "storage_key": "property/6737460151192634/019e1de6-a4bc-777b-a38a-fbdc6e944de9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.connectonthedot.com/home/routes-schedules/savannah-belles-ferry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557906027025054417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-belles-ferry",
      "poi_latitude": "32.0815891",
      "poi_longitude": "-81.0872794",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1_Hp2Se-4gR0bpw_GHvQD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "custom_1fdf2923-417c-4227-9ebd-fc95123e7a5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "River Street Market Place",
      "poi_type": "Transportation & Transit",
      "poi_address": "502 E River St #32, Savannah, GA 31401, USA",
      "poi_short_description": "Trendy covered marketplace with a variety of cafes/bars & kiosks selling gifts, jewelry & more.",
      "poi_long_description": "Trendy covered marketplace with a variety of cafes/bars & kiosks selling gifts, jewelry & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-a5fb-7692-9cda-304d45274996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-a5fb-7692-9cda-304d45274996",
        "storage_key": "property/6737460151192634/019e1de6-a5fb-7692-9cda-304d45274996.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverstreetmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3892914873212584741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-street-market-place",
      "poi_latitude": "32.0804911",
      "poi_longitude": "-81.0858499",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 912-629-2647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b692-7256-b7e3-fbf8a508e96f",
        "storage_key": "property/6737460151192634/019e1de4-b692-7256-b7e3-fbf8a508e96f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6ztjSHue-4gRJcOrnnNpBjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_70002305-cf0d-43b9-8102-73d65bd2411e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Georgia Ports Authority Ocean Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "55 N Lathrop Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-aa38-711b-ac61-dbb33384f6dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-aa38-711b-ac61-dbb33384f6dd",
        "storage_key": "property/6737460151192634/019e1de6-aa38-711b-ac61-dbb33384f6dd.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://gaports.com/facilities/port-of-savannah/ocean-terminal/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11431752285097839084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority-ocean-terminal",
      "poi_latitude": "32.0911818",
      "poi_longitude": "-81.1065034",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-963-5526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bDfXfme-4gR7EmEoSK-pZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d48169db-4d4c-4b2e-97f5-9dab2913cdb8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah Convention Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 International Dr, Savannah, GA 31421, USA",
      "poi_short_description": "Venue for conventions, trade shows, sporting meets and other events, with a free ferry.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-a64a-74bc-a14b-5180fe6e8f5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-a64a-74bc-a14b-5180fe6e8f5f",
        "storage_key": "property/6737460151192634/019e1de6-a64a-74bc-a14b-5180fe6e8f5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.savconventioncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751869557279509759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-convention-center",
      "poi_latitude": "32.0838296",
      "poi_longitude": "-81.0878429",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-447-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-JNu2Ke-4gR_0w_7XtRETQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_8fc7f611-6ec5-47c4-be48-615c385b248b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Candler Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5353 Reynolds St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-9d95-74f4-adf8-1e5e7e5164fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-9d95-74f4-adf8-1e5e7e5164fc",
        "storage_key": "property/6737460151192634/019e1de4-9d95-74f4-adf8-1e5e7e5164fc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sjchs.org/locations/locationdetails/candler-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058112974386619187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "candler-hospital",
      "poi_latitude": "32.0281014",
      "poi_longitude": "-81.1003141",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-819-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b692-7256-b7e3-f5442bafed8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b692-7256-b7e3-f5442bafed8f",
        "storage_key": "property/6737460151192634/019e1de4-b692-7256-b7e3-f5442bafed8f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb2fD5N1-4gRM-PXE90FV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4e8c8baa-6289-412b-88fe-f9b73d60ae07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-9ae3-71bb-99d5-589f9b4024c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-9ae3-71bb-99d5-589f9b4024c1",
        "storage_key": "property/6737460151192634/019e1de4-9ae3-71bb-99d5-589f9b4024c1.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b692-7256-b7e3-f5442bafed8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b692-7256-b7e3-f5442bafed8f",
        "storage_key": "property/6737460151192634/019e1de4-b692-7256-b7e3-f5442bafed8f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8cfbbebe-6824-4210-a8b7-f476944f6d49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah College of Art and Design",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Drayton St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-8119-7387-81e4-ac04b07ce6bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-8119-7387-81e4-ac04b07ce6bd",
        "storage_key": "property/6737460151192634/019e1de4-8119-7387-81e4-ac04b07ce6bd.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.scad.edu/locations/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151614706338739018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-college-of-art-and-design",
      "poi_latitude": "32.0691097",
      "poi_longitude": "-81.0938141",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-525-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUzHD2me-4gRSrMTb2d95_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_45d0f053-f24e-4ffa-8664-02c7b90badc8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Georgia Southern University Armstrong Campus Savannah",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11935 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-83ce-747f-9774-cc8c6501d418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-83ce-747f-9774-cc8c6501d418",
        "storage_key": "property/6737460151192634/019e1de4-83ce-747f-9774-cc8c6501d418.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/armstrong-campus-savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=783516353767565760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-armstrong-campus-savannah",
      "poi_latitude": "31.9786073",
      "poi_longitude": "-81.1634639",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9h8y0oL-4gRwGkG9vib3wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d4d54a3d-ad6e-4973-bd0e-e198843a8ecd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3219 College St, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-8102-75b8-a93d-a05cf1d6e141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de4-8102-75b8-a93d-a05cf1d6e141",
        "storage_key": "property/6737460151192634/019e1de4-8102-75b8-a93d-a05cf1d6e141.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://savannahstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=170532476337488424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-state-university",
      "poi_latitude": "32.0241968",
      "poi_longitude": "-81.0625787",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-358-4162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6ef-749d-80e9-bc6f462e1857",
        "storage_key": "property/6737460151192634/019e1de4-b6ef-749d-80e9-bc6f462e1857.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5BqurZ3-4gRKILDOmLaXQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_18834678-68da-439b-a89c-402653122ffd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-ab4d-763b-88aa-24642f03fa13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-ab4d-763b-88aa-24642f03fa13",
        "storage_key": "property/6737460151192634/019e1de6-ab4d-763b-88aa-24642f03fa13.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "16.8",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_5a3cb4b8-7d21-4193-9592-1afffb92435b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-ab01-70ad-b422-ad22741e9b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-ab01-70ad-b422-ad22741e9b90",
        "storage_key": "property/6737460151192634/019e1de6-ab01-70ad-b422-ad22741e9b90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b693-7188-9158-166db6fdcbcd",
        "storage_key": "property/6737460151192634/019e1de4-b693-7188-9158-166db6fdcbcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dffd47a0-ec13-4098-b3bf-5307f9878029",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-cdcc-70ba-85ce-9b18bf2e18ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-cdcc-70ba-85ce-9b18bf2e18ea",
        "storage_key": "property/6737460151192634/019e1de6-cdcc-70ba-85ce-9b18bf2e18ea.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "16.4",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de4-b6b1-749f-86b3-d65b4d7f55cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de4-b6b1-749f-86b3-d65b4d7f55cd",
        "storage_key": "property/6737460151192634/019e1de4-b6b1-749f-86b3-d65b4d7f55cd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8ecd9ca9-d79d-4553-9f39-a4277674d93d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Hunter Army Airfield Deers, AWS, and more",
      "poi_type": "Major Employers & Offices",
      "poi_address": "171 Haley Ave, Savannah, GA 31409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://home.army.mil/stewart/about/Garrison/DHR/MPD/id-cards-deers",
      "poi_directions_map_url": "https://maps.google.com/?cid=12070937004809537966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hunter-army-airfield-deers-aws-and-more",
      "poi_latitude": "32.0241332",
      "poi_longitude": "-81.1267738",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-315-5726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d7a0-773b-9f01-713790b912d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d7a0-773b-9f01-713790b912d3",
        "storage_key": "property/6737460151192634/019e1de6-d7a0-773b-9f01-713790b912d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWZvDZ3k-ogRrknKVUCVhKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94dac4c0-d1fe-47b8-bcda-8a76d9f8bcc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "custom",
      "poi_name": "Chatham County Courthouse Complex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "133 Montgomery St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-ae3d-707a-bdf8-c453735bfbc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de6-ae3d-707a-bdf8-c453735bfbc4",
        "storage_key": "property/6737460151192634/019e1de6-ae3d-707a-bdf8-c453735bfbc4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://courts.chathamcountyga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7030595360416217569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chatham-county-courthouse-complex",
      "poi_latitude": "32.0791956",
      "poi_longitude": "-81.0971508",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-652-7175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019e1de6-d7a0-773b-9f01-713790b912d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de6-d7a0-773b-9f01-713790b912d3",
        "storage_key": "property/6737460151192634/019e1de6-d7a0-773b-9f01-713790b912d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bKbjmee-4gR4TkeCTuxkWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_91b8772741833dbb97a9c790",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f1f443799acc4b6c5042b26d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fffa2eb1c3268aeb235e9819",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0eb04e94f40f5c9b4badc2da",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5c218b213b26e62d8828f521",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_87fccb5238fa31fb6c38a43f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1c4aa9a2-72d5-48bc-920e-40affdc5430d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "rating": "5",
      "name": "brittney jackson",
      "text": "My experience with the previous management left me hesitant about renewing my lease due to their disrespectful behavior and their disregard for my concerns, which made me feel inadequate.\n\nHowever, I want to express my gratitude to Dominique and Brittany for transforming the atmosphere here. There are now more community events, and I truly appreciate their extensive knowledge and understanding. They listen with empathy and compassion to the issues I bring to them, without any attitude.\n\nThank you both for all your support!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_f7507a0c-5031-47b7-b1e3-521398b8b63f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "rating": "5",
      "name": "Emonie Maxwell",
      "text": "Brittany was absolutely amazing! Super professional, well spoken, clear and upfront! I highly recommend working with her!",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_6bea1368-f3cd-4ff2-9583-bcd5b795009e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "rating": "5",
      "name": "lathania ricketts",
      "text": "I had a great experience with the team at Carriage House Apartments. Dominique and Brittany were both very helpful, professional, and welcoming throughout the process. They made everything smooth and easy during my move, and they were always ready to answer any questions I had.\n\nBrittany in particular was very hardworking, confident, and determined to make sure everything was handled properly. You can tell she really cares about helping people and doing a great job. I truly appreciate the support and excellent service I received.\n\nThank you both for making this such a positive experience!",
      "date": "2026-03-13",
      "title": "false"
    },
    {
      "id": "custom_c7854b44-c3f9-4df9-bec0-0cd690c61ce0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "rating": "5",
      "name": "Nova Williams",
      "text": "100/10. Calvin, Justin, and Brittany!!\n\nI have lived here for YEARS. Will be here for many more Been here through multiple managers and maintence teams. Loved our last management/maintence team and loving this new team overall. They are so awesome. My husband and I are so very grateful for them.\n\nOur dryer has been broken and they came and gave us a new one!! Wowzer!!! Brittany in the office is so sweet and kind. She was very patient with me as I asked about dryer updates. I am so thankful for her communication and responsiveness.\n\nAnd SHOUTOUT to Calvin and Justin for hauling that HUGE dryer in!!! I was never so grateful to see them than that moment😂😂. Our laundry might rival Mt. Everest now 😂😂. My superheroes in blue for real. They were so sweet and awesome to bring us a new dryer. We are very grateful that they brought it in and installed it for us!\n\nEveryone is so responsive and kind. They answer all my questions and get to things as fast as possible! I highly recommend living here.",
      "date": "2026-02-20",
      "title": "false"
    },
    {
      "id": "custom_9c5e6af9-5bf9-49c8-880a-dd8c4416662d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "rating": "5",
      "name": "Kenyatta Groover",
      "text": "Britney is amazing. She made the process of me moving so easy!",
      "date": "2026-03-20",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e27-47e6-724a-8f17-6cfe8898c4fe",
      "lead_source": "LANDING_PAGE",
      "name": "rr-living-carriage-house-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634"
    },
    {
      "lead_collector_id": "019a2718-f7e0-77c4-8979-421297259dfa",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-carriage-house-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634"
    },
    {
      "lead_collector_id": "019d6351-00e2-746e-8931-790bd03f462e",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-savannah",
      "search_query": "apartments with in-unit laundry Savannah GA",
      "category": "Amenity",
      "h1_title": "Savannah Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry in Savannah, GA. Experience the blend of convenience and style at Carriage House.",
      "page_copy": "At Carriage House in Savannah, GA, enjoy the ultimate convenience of apartments with in-unit laundry, offering all the modern comforts. Whether you're in search of a one-bedroom retreat or a three-bedroom home, our residences provide the perfect setting for your lifestyle. Enhance your daily routine with resort-style amenities like our sparkling pool and state-of-the-art fitness center.\n\nLocated in the Wilshire Estates-Savannah Mall area, Carriage House presents a welcoming community atmosphere complemented by on-site maintenance, planned social activities, and a spacious balcony for each unit. Experience the luxuries of a modern home that includes cable-ready features and a barbecue grill area for socializing. Embrace a new level of living where convenience meets elegance. Schedule a tour today and see why Carriage House is the ideal spot for apartment living in Savannah, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah In-Unit Laundry Apartments",
      "seo_description": "Explore Savannah, GA apartments with in-unit laundry at Carriage House. Enjoy modern amenities and a great location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-wilshire-estates",
      "search_query": "luxury apartments with pool Wilshire Estates",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Wilshire Estates",
      "h2_subtitle": "Discover luxury living with a pool in Wilshire Estates. Carriage House offers unmatched amenities in Savannah's sought-after neighborhood.",
      "page_copy": "Experience the best of luxury living at Carriage House, nestled within Savannah’s vibrant Wilshire Estates. Our premium apartments offer splendid resort-style amenities, including a stunning pool that invites relaxation and leisure. Choose from cozy one-bedroom layouts to expansive three-bedroom homes, all designed with modern elegance and convenience in mind.\n\nAs a Carriage House resident, enjoy our array of upscale amenities such as a cutting-edge fitness center and a lounge area perfect for unwinding. Each apartment is cable ready and features a private balcony, providing the ultimate in both comfort and style. Delight in our planned social activities and grill area which enrich the community spirit of our Chatham County sanctuary. Elevate your lifestyle by becoming part of our exclusive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wilshire Estates Luxury Apartments with Pool",
      "seo_description": "Explore luxury apartments with a pool in Wilshire Estates at Carriage House, Savannah. Enjoy top amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "washer-dryer-hookups-chatham-rentals",
      "search_query": "washer dryer hookups Chatham County rentals",
      "category": "Amenity",
      "h1_title": "Chatham County Rentals with Washer Dryer Hookups",
      "h2_subtitle": "Find rentals with washer dryer hookups in Chatham County. Carriage House offers comfort and convenience in Savannah, GA.",
      "page_copy": "Welcome to Carriage House, your ideal choice for rentals in Chatham County that offer the convenience of washer dryer hookups. Located in charming Savannah, GA, our community provides a variety of living options from intimate one-bedroom units to expansive three-bedroom homes, all designed to meet your unique lifestyle needs.\n\nSituated in the welcoming Wilshire Estates-Savannah Mall area, Carriage House ensures a blend of comfort and community. Enjoy resort-style amenities, including a sparkling pool and a modern fitness center. Each apartment is cable ready with a private balcony, promoting both comfort and relaxation. Experience maintenance-free living and join in on planned social activities that foster a sense of community. Discover the ease and luxury of having washer dryer hookups available in your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chatham Rentals with Washer Dryer Hookups",
      "seo_description": "Discover Chatham County rentals with washer dryer hookups at Carriage House, Savannah. Experience modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "air-conditioned-apartment-homes-savannah-mall",
      "search_query": "air conditioned apartment homes Savannah Mall",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Savannah Mall",
      "h2_subtitle": "Enjoy air conditioned apartment homes near Savannah Mall at Carriage House. Comfort meets convenience in a prime Savannah location.",
      "page_copy": "Nestled in the heart of Savannah, GA, Carriage House offers ideally located air conditioned apartment homes near the Savannah Mall. Choose from our selection of one to three-bedroom apartments, all featuring modern conveniences that are perfect for every lifestyle, providing a cool oasis during warm Georgia days.\n\nOur community in the Wilshire Estates-Savannah Mall area blends comfort with convenience, offering residents access to a variety of amenities. Relax by the sparkling pool, stay fit in our modern fitness center, and embrace the pleasant social environment with planned activities. Each apartment includes a private balcony and impressive amenities like cable readiness and on-site maintenance, ensuring a hassle-free living experience. Experience the comfort of air conditioned apartment homes today at Carriage House.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apts Near Savannah Mall",
      "seo_description": "Find air conditioned apartment homes near Savannah Mall at Carriage House, offering modern living and great amenities in Savannah, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-near-31406",
      "search_query": "apartments with dishwashers near 31406",
      "category": "Amenity",
      "h1_title": "Savannah Apartments with Dishwashers Near 31406",
      "h2_subtitle": "Discover convenient living with apartments that include dishwashers near the 31406 area. Carriage House offers unparalleled comfort and amenities.",
      "page_copy": "Explore comfortable living at Carriage House, located in the sought-after area near 31406, Savannah. Our thoughtfully designed apartments include dishwashers, adding ease to your daily routine. Whether you opt for a cozy one-bedroom or need space with our three-bedroom options, our residences are equipped to meet diverse needs.\n\nSituated in the vibrant Wilshire Estates-Savannah Mall neighborhood, Carriage House combines modern living with a welcoming atmosphere. Enjoy an array of community amenities from a pristine pool to a fully-equipped fitness center, along with cable-ready units featuring private balconies. Experience planned social activities that enhance community living, all while enjoying the convenience of living close to local attractions. Make Carriage House your home and enjoy the blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah Apts with Dishwashers Near 31406",
      "seo_description": "Find apartments with dishwashers near 31406 at Carriage House in Savannah, offering modern comfort and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-wilshire-estates-savannah",
      "search_query": "1 bedroom apartment wilshire estates savannah",
      "category": "Floorplan",
      "h1_title": "1-Bedroom Apartments in Wilshire Estates",
      "h2_subtitle": "Explore 1-bedroom apartments in Wilshire Estates, Savannah. Carriage House offers a perfect blend of comfort and convenience.",
      "page_copy": "Discover the ideal retreat at Carriage House with our charming 1-bedroom apartments located in Wilshire Estates, Savannah. Designed to offer both functionality and style, our apartments are perfect for individuals or couples looking for a cozy living space in a vibrant community.\n\nLocated near the Savannah Mall, our community provides easy access to shopping, dining, and entertainment options. Enjoy amenities such as a refreshing pool, a modern fitness center, and an inviting lounge. Each apartment is cable-ready and features a private balcony, perfect for unwinding after a long day. Participate in planned social activities, all within a community that values comfort and convenience. See why our 1-bedroom apartments in Wilshire Estates are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1-Bedroom Apartments Wilshire Estates, Savannah",
      "seo_description": "Find 1-bedroom apartments in Wilshire Estates at Carriage House, Savannah. Enjoy comfort and modern amenities near Savannah Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "2-bedroom-apartment-chatham-county",
      "search_query": "2 bedroom apartment chatham county",
      "category": "Floorplan",
      "h1_title": "2-Bedroom Apartments in Chatham County",
      "h2_subtitle": "Discover modern 2-bedroom apartments in Chatham County at Carriage House. Enjoy spacious living with a host of desirable amenities.",
      "page_copy": "Carriage House offers inviting 2-bedroom apartments in the heart of Chatham County, providing the perfect balance of space and modern conveniences. Ideal for small families or roommates, these thoughtfully designed homes cater to those seeking a little extra room without sacrificing comfort.\n\nSituated in the picturesque area of Savannah, our community is equipped with premium amenities, including a sparkling pool and a state-of-the-art fitness center. Engage with neighbors through our planned social activities or relax on your private balcony. With cable-ready apartments and maintenance on-site, you'll find everything you need right at your doorstep. Experience the warmth and charm of 2-bedroom living at Carriage House in Chatham County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2-Bedroom Apartments Chatham County, GA",
      "seo_description": "Explore 2-bedroom apartments in Chatham County at Carriage House, featuring spacious designs and modern amenities in a prime Savannah location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192634",
      "source": "generator",
      "page_item_url": "3-bedroom-apartment-near-31406",
      "search_query": "3 bedroom apartment near 31406",
      "category": "Floorplan",
      "h1_title": "Spacious 3-Bedroom Apartments Near 31406",
      "h2_subtitle": "Find roomy 3-bedroom apartments near the 31406 area. Carriage House offers ideal living spaces with exceptional amenities.",
      "page_copy": "Experience the luxury of spacious living with our 3-bedroom apartments near the 31406 area at Carriage House in Savannah. Designed for families or those who enjoy extra room, our apartments provide ample space for comfortable living. Each unit is thoughtfully equipped with modern conveniences, making daily life a breeze.\n\nNestled in the lively Wilshire Estates-Savannah Mall neighborhood, Carriage House offers a vibrant community atmosphere. Enjoy our resort-style pool, fully-equipped fitness center, and numerous planned social activities. Each apartment is cable-ready with a private balcony, offering both entertainment and relaxation opportunities right at home. Choose Carriage House for a lifestyle that combines modern comfort with the charm of Savannah living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground",
        "public_id": "019d0784-3a5b-704e-aa32-cf7d5b145d65",
        "storage_key": "property/6737460151192634/019d0784-3a5b-704e-aa32-cf7d5b145d65.webp",
        "width": 1123,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3-Bedroom Apartments Near 31406, Savannah",
      "seo_description": "Discover spacious 3-bedroom apartments near 31406 at Carriage House in Savannah, offering modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3366"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483286"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4857246"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KVLV98MX"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "912-301-2105"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "912-301-3503"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "912-301-3386"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "912-301-3556"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "912-301-3530"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "912-301-3352"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "912-301-3423"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "912-301-3157"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "912-301-3278"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "912-617-9433"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "912-325-3498"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "912-301-3487"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "912-551-6688"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "912-642-9157"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "912-205-3617"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "912-378-4432"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "912-301-3162"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "912-616-5507"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321177756"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "912-301-3429"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "912-461-7045"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "ea2c742d01afa11e"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "912-741-3789"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "912-301-3524"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "912-378-4784"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "912-301-3066"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "912-301-3574"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "912-301-3547"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.carriagehousesavannah.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192634/019e60e3-90e8-74aa-b791-f419a228887b.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "912-301-3358"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "912-617-9433"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3366",
  "custom_repli_id": "5028483286",
  "custom_realpage_id": "4857246",
  "custom_knock_a_link": "https://www.carriagehousesavannah.com?utm_knock=a",
  "custom_knock_g_link": "https://www.carriagehousesavannah.com?utm_knock=g",
  "custom_knock_r_link": "https://www.carriagehousesavannah.com?utm_knock=r",
  "custom_knock_w_link": "https://www.carriagehousesavannah.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KVLV98MX",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.carriagehousesavannah.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.carriagehousesavannah.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.carriagehousesavannah.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.carriagehousesavannah.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.carriagehousesavannah.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.carriagehousesavannah.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "912-301-2105",
  "custom_knock_ads_link": "https://www.carriagehousesavannah.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.carriagehousesavannah.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "912-301-3503",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.carriagehousesavannah.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.carriagehousesavannah.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.carriagehousesavannah.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.carriagehousesavannah.com?utm_knock=psa",
  "custom_knock_r_number": "912-301-3386",
  "custom_knock_w_number": "912-301-3556",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "912-301-3530",
  "custom_knock_amap_link": "https://www.carriagehousesavannah.com?utm_knock=amap",
  "custom_knock_ar_number": "912-301-3352",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "912-301-3423",
  "custom_knock_fb_number": "912-301-3157",
  "custom_knock_fl_number": "912-301-3278",
  "custom_knock_gp_number": "912-617-9433",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.carriagehousesavannah.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "912-325-3498",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.carriagehousesavannah.com?utm_knock=bcard",
  "custom_knock_bnr_number": "912-301-3487",
  "custom_knock_cfres_link": "https://www.carriagehousesavannah.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "912-551-6688",
  "custom_knock_lgp_number": "912-642-9157",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.carriagehousesavannah.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "912-205-3617",
  "custom_knock_psa_number": "912-378-4432",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "912-301-3162",
  "custom_knock_bandit_link": "https://www.carriagehousesavannah.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.carriagehousesavannah.com?utm_knock=flyers",
  "custom_knock_osoc_number": "912-616-5507",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321177756",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "912-301-3429",
  "custom_knock_cfres_number": "912-461-7045",
  "custom_knock_community_id": "ea2c742d01afa11e",
  "custom_knock_dirmail_link": "https://www.carriagehousesavannah.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "912-741-3789",
  "custom_knock_propbro_link": "https://www.carriagehousesavannah.com?utm_knock=propbro",
  "custom_knock_bandit_number": "912-301-3524",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "912-378-4784",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.carriagehousesavannah.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_dirmail_number": "912-301-3066",
  "custom_knock_propbro_number": "912-301-3574",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "912-301-3547",
  "custom_knock_maintenance_link": "https://www.carriagehousesavannah.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192634/019e60e3-90e8-74aa-b791-f419a228887b.mp4",
  "custom_knock_maintenance_number": "912-301-3358",
  "custom_ppc_tracking_phone_number": "912-617-9433",
  "custom_audioeye_site_id": "502d4e90-7b8a-40ff-b1af-d995a95bc3af",
  "custom_audioeye_site_hash": "0336bf79ce4c572f05598849d836f3bf"
};

export const generatedAt = '2026-10-27T16:17:37.199Z';
